import { render, staticRenderFns } from "./SaveDataAdapter.vue?vue&type=template&id=485570c9&"
import script from "./SaveDataAdapter.vue?vue&type=script&lang=js&"
export * from "./SaveDataAdapter.vue?vue&type=script&lang=js&"
import style0 from "./SaveDataAdapter.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports